/* import Swiper core, modules, and css */
// import Swiper from 'swiper';
// import { Pagination, Autoplay, Navigation } from 'swiper/modules'; // import Swiper modules (if needed). Full list available here: https://swiperjs.com/swiper-api#modules

import './index.scss'

class ExampleBlock {
    constructor(el) {
        this.$el = el

        console.log('ExampleBlock::constructor')
    }
    // init() {}
}

document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.querySelectorAll('.example-block')).forEach($block => {
        $block.expandygg = new ExampleBlock($block)
    })
}, {capture: false, passive: true, once: true} || false)